import { FC } from 'react';

import styled from '@emotion/styled';

import { isEmpty } from 'lodash-es';

import { BcAlert } from '@britishcouncil/react-solas-ors3';
import { ServerError } from '@britishcouncil/react-forms';

export const ServerErrors: FC<{ errors?: ServerError[]; title?: string }> = ({
  errors,
  title,
}) => {
  return !isEmpty(errors) ? (
    <StyledAlert title={title} type="danger">
      {errors!.map((x, i) => (
        <p key={i}>{x.message}</p>
      ))}
    </StyledAlert>
  ) : null;
};

const StyledAlert = styled(BcAlert)`
  margin-bottom: 20px; ;
`;
